import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_4mu3tt6g8r: FaireCollectionEntity = {
  token: "pbc_4mu3tt6g8r",
  type: "collection",
  name: "scripture cards",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c418d714cc987e2cf63838012156e65a2756e2763cfac67f3258ff680267c00d.jpeg",
  itemCount: 9,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:23.098Z",
    importedBy: "entity-db-import-collections",
  },
};
